import React from "react";
import Button from "../../src/Resources/Forms/Button";

const EmptyState = (props) => (
  <div className="no-enq" style={{ margin: props.margin || "" }}>
    <div className="no-enq-img">
      <img
        src="Images/no-lead.svg"
        alt=""
        style={{ height: props.height || props.size || "" }}
      />
    </div>
    {props.text && (
      <div
        className="no-enq-text"
        style={{
          fontWeight: props.lightText ? 400 : "",
          color: props.lightText ? "#5e7079" : "",
          marginTop: props.lightText ? "-10px" : "",
        }}
      >
        {props.text}
      </div>
    )}
    {props.action && (
      <div
        className="no-enq-link"
        style={{ display: "flex", justifyContent: "center" }}
      >
        <Button
          type={props.buttonType || "primary"}
          text={props.actionText}
          noMargin={true}
          onClick={() => props.action()}
        />
      </div>
    )}
  </div>
);

export default EmptyState;
